@if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}
<nh-form
  [topLevelName]="'li'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ 'LIFE_INSURANCE_TOP_LEVEL' | globalTranslate }}"
  individualQuestion="{{ 'LIFE_INSURANCE_INDIV_QUES' | globalTranslate }}"
  [hintText]="hintText"
  (validate)="onValidate($event)"
>
  <br />
  @if (!isRmbRmc) {
  <h1 class="section-header">
    {{ "LIFE_INSURANCE_TITLE" | globalTranslate }}
  </h1>
  } @if (isRmbRmc) {
  <h1 class="section-header">
    {{ "LIFE_INSURANCE_TITLE_RMBC" | globalTranslate }}
  </h1>
  }
  <hr />

  <section [formGroup]="getControl('data')">
    <nh-field
      id="li_assetType"
      label="{{ 'LIFE_INSURANCE_STATIC_TEXT1' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }} <div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'LIFE_INSURANCE_STATIC_TEXT2' | globalTranslate
      }}</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        [items]="tableCodeValue('DCLIFEINSURANCETYPE', 'data.assetType')"
        (change)="assetTypeValidate()"
        formControlName="assetType"
        [attr.aria-label]="
          ('LIFE_INSURANCE_STATIC_TEXT1' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        aria-required="true"
      ></select>
    </nh-field>
    <nh-field
      id="li_faceAmount"
      label="{{ 'LIFE_INSURANCE_STATIC_TEXT3' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        [content]="'LIFE_INSURANCE_STATIC_TEXT4' | globalTranslate"
      ></nh-popover>
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          name="faceAmount"
          [attr.aria-label]="'LIFE_INSURANCE_STATIC_TEXT3' | globalTranslate"
          formControlName="faceAmount"
          class="form-control"
          aria-required="true"
        />
      </nh-input-group>
    </nh-field>
    @if (isEnabled('data.assetAmount')) {
    <section>
      <nh-field
        id="li_assetAmount"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'LIFE_INSURANCE_STATIC_TEXT5' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'LIFE_INSURANCE_STATIC_TEXT6' | globalTranslate"
        ></nh-popover>
        <nh-input-group prepend="$">
          <input
            nh
            type="text"
            placeholder="0.00"
            mask="separator.2"
            thousandSeparator=""
            separatorLimit="999999999"
            name="assetAmount"
            [attr.aria-label]="'LIFE_INSURANCE_STATIC_TEXT5' | globalTranslate"
            formControlName="assetAmount"
            class="form-control"
          />
        </nh-input-group>
      </nh-field>
    </section>
    }
    <nh-field
      id="li_policyNumber"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'POLICY_NUMBER' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="policyNumber"
        [attr.aria-label]="'POLICY_NUMBER' | globalTranslate"
        formControlName="policyNumber"
        maxlength="16"
        class="form-control"
      />
    </nh-field>
    <br />
    <h2 class="section-header">
      {{ "LIFE_INSURANCE_TITLE2" | globalTranslate }}
    </h2>
    <hr />
    <nh-alert type="warning" [isOpen]="getControl('data.assetAddress').touched">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ "ADDRESS_WARNING" | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
    <nh-field
      id="li_insuranceName"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'COMPANY_NAME' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="insuranceName"
        [attr.aria-label]="'COMPANY_NAME' | globalTranslate"
        formControlName="insuranceName"
        maxlength="50"
        class="form-control"
      />
    </nh-field>
    <nh-name-address
      [addressname]="'li_assetAddress'"
      [addressFieldMandatory]="false"
      [addressFormat]="null"
      [stateDefault]="false"
      [showPopup]="false"
      [address]="getControl('data.assetAddress')"
      [tables]="tables"
      [hideCounty]="true"
    ></nh-name-address
    ><br />
    <nh-field
      id="li_phoneNumber"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'PHONE_NUMBER2' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="phoneNumber"
        formControlName="phoneNumber"
        [attr.aria-label]="'PHONE_NUMBER2' | globalTranslate"
        class="form-control"
        mask="000-000-0000"
        placeholder="XXX-XXX-XXXX"
      />
    </nh-field>
  </section>
</nh-form>